module.exports = __webpack_public_path__ + "moonhouse.d41d8cd98f00b204e980.eot";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/deal-or-no-deal-prizes-server/admin/src/web/src/assets/fonts/moonhouse.eot
// module id = ../../../../../src/assets/fonts/moonhouse.eot
// module chunks = styles